import Shop from '../shop';

export default class LampStore extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Lamp store',
            id:                   'LampStore',
            coolDown:             300,
            faClass:              'fa-lightbulb-o',
            individualCostFactor: 1.13,
            baseEarnings:         622080.0,
            baseCosts:            1244160.0,
            grade:                6
        });
    }
}
